module.exports = __webpack_public_path__ + "img/b385e617782794a9ab5b0be9ea1d42ec.png";